import { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

interface AppShellProps {
  children?: ReactNode;
  title: string;
  eyebrow: string;
  description: string;
  showBackLink?: boolean;
}

export default function AppShell({
  children,
  title,
  eyebrow,
  description,
  showBackLink = false,
}: AppShellProps) {
  const location = useLocation();

  return (
    <div className="app-shell">
      <header className="topbar">
        <div className="topbar__brand">
          <img className="topbar__logo" src="/assets/Group.png" alt="Edible" />
          <div>
            <p className="topbar__eyebrow">MyEdible Corporate</p>
            <p className="topbar__product">Launchpad</p>
          </div>
        </div>

        <nav className="topbar__nav">
          <Link
            className={`topbar__nav-link${location.pathname === "/" ? " topbar__nav-link--active" : ""}`}
            to="/"
          >
            Dashboard
          </Link>
          <Link
            className={`topbar__nav-link${location.pathname.startsWith("/communications") ? " topbar__nav-link--active" : ""}`}
            to="/communications"
          >
            New Communication
          </Link>
          <Link
            className={`topbar__nav-link${location.pathname.startsWith("/campaigns") ? " topbar__nav-link--active" : ""}`}
            to="/campaigns"
          >
            Campaign History
          </Link>
        </nav>

        {showBackLink ? (
          <Link className="topbar__link" to="/">
            Back to dashboard
          </Link>
        ) : (
          <span className="topbar__tag">Corporate workspace</span>
        )}
      </header>

      <main className="page">
        <section className="hero">
          <div className="hero__card">
            <div className="hero__text">
              <p className="hero__eyebrow">{eyebrow}</p>
              <h1>{title}</h1>
              <p>{description}</p>
            </div>
            <div className="hero__badge-panel">
              <img className="hero__mark" src="/assets/EdibleLogoRed.svg" alt="Edible mark" />
              <div className="hero__badge">
                <span>Built for corporate operations</span>
                <strong>Audience selection, composition, and API-ready delivery.</strong>
              </div>
            </div>
          </div>
        </section>

        {children}
      </main>
    </div>
  );
}
